import { ContentSection, Heading, Primary } from '@cinch-labs/design-system'
import type { StoryBlokRichText } from '@cinch-nx/data-storyblok'
import {
  StoryblokRenderer,
  renderWithResolver,
} from '@cinch-nx/landing-ui-shared'
import { useCookieModalOpen } from '@cinch-nx/shared-ui'

import { storyblokComponents } from '../../data/storyblok-renderer-map'
import { DeleteCookiesSection, TableSection } from '../../types/policy-page'
import styles from './cookie-policy-section.module.css'

export type Props = {
  title: string
  intro: StoryBlokRichText
  content: StoryBlokRichText
  buttonText: string
  tableSection: TableSection
  deleteSection: DeleteCookiesSection
}

export const CookiePolicySection: React.FC<Props> = ({
  title,
  intro,
  content,
  buttonText,
  tableSection,
  deleteSection,
}) => {
  const { setIsPreferencesModalOpen } = useCookieModalOpen()
  return (
    <section className={styles.container}>
      <Heading element="h2" className={styles.title} fontSize="h1">
        {title}
      </Heading>
      <ContentSection
        classNames={{
          body: 'storyblokRichTextBody',
        }}
      >
        {renderWithResolver(intro)}
      </ContentSection>
      <ContentSection>
        <Primary
          type="button"
          name={buttonText}
          value={buttonText}
          onClick={() => setIsPreferencesModalOpen(true)}
        >
          {buttonText}
        </Primary>
      </ContentSection>
      <ContentSection
        classNames={{
          body: 'storyblokRichTextBody',
        }}
      >
        {renderWithResolver(content)}
      </ContentSection>

      {tableSection && (
        <StoryblokRenderer
          block={tableSection}
          components={storyblokComponents}
        />
      )}
      {deleteSection && (
        <StoryblokRenderer
          block={deleteSection}
          components={storyblokComponents}
        />
      )}
    </section>
  )
}

export default CookiePolicySection
